//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
  name: 'miniUserManage',
  components: {cmBlank, cmLoadmore},
  data(){
    return {
      keyword:'', list:[], tagOptions:[], selectedTagId:0, blankShow:false,
      loadStatus:false, loadmoreText:'正在加载。。。', busy:false, hasNext:0, pageFlag:2, lastId:0,
      panel:'', currentUser:{}, submitting:false, detailLoading:false, detailList:[], qrcodeUrl:'',
      detailLastId:0, detailHasNext:0, detailFinished:false, detailRequestKey:0, detailPageSize:15,
      memberForm:{uid:0,name:'',phone:'',sex:0,birthday:''},
      rechargeForm:{money:'',gift:'',remark:''},
      memberOptions:{cards:[],packages:[]}, assignType:1, assignCardId:0,
      checkedTagIds:[], recordType:'balance',
      assignTabs:[{value:1,label:'折扣卡'},{value:2,label:'储值卡'},{value:3,label:'年卡'},{value:4,label:'次卡'}],
      recordTabs:[{value:'free',label:'次卡'},{value:'balance',label:'余额'},{value:'consume',label:'消费'}]
    }
  },
  computed:{
    panelTitle(){
      const titles = {memberForm:this.memberForm.uid ? '编辑会员' : '新增会员',recharge:'会员充值',assign:'分配会员卡',receive:'会员收衣',more:'会员操作',cards:'会员卡',records:'会员记录',qrcode:'会员通知码',tags:'设置标签'};
      return titles[this.panel] || '会员管理';
    },
    assignmentOptions(){
      if(this.assignType === 4) return this.memberOptions.packages || [];
      return (this.memberOptions.cards || []).filter(item=>Number(item.type) === this.assignType);
    }
  },
  created(){
    this.getTagOptions();
    this.getMemberOptions();
    this.loadmore();
  },
  methods:{
    search(){
      this.list=[]; this.lastId=0; this.hasNext=0; this.blankShow=false; this.busy=false;
      this.loadmore();
    },
    resetSearch(){ this.keyword=''; this.search(); },
    getList(){
      return this.$api.miniUserList({last_id:this.lastId,page_flag:this.pageFlag,keyword:this.keyword,tag_id:this.selectedTagId}).then(res=>{
        if(!res) return;
        const rows=Array.isArray(res.data) ? res.data : [];
        if(!this.lastId) this.blankShow=rows.length === 0;
        this.hasNext=res.hasNext; this.lastId=res.lastId;
        rows.forEach(item=>this.list.push(item));
      });
    },
    loadmore(){
      if(this.lastId > 0 && !this.hasNext){ this.busy=true; this.loadStatus=true; this.loadmoreText='没有更多了。。。'; return; }
      this.busy=true; this.loadStatus=true; this.loadmoreText='正在加载。。。';
      this.getList().finally(()=>{
        if(this.blankShow){ this.busy=true; this.loadStatus=false; }
        else if(this.hasNext > 0){ this.busy=false; this.loadStatus=false; }
        else{ this.busy=true; this.loadStatus=true; this.loadmoreText='没有更多了。。。'; }
      });
    },
    getTagOptions(){ this.$api.miniUserTagOptions({}).then(res=>{ if(res) this.tagOptions=Array.isArray(res.data) ? res.data : []; }); },
    getMemberOptions(){ this.$api.miniMemberOptions({}).then(res=>{ if(res && res.data && !Array.isArray(res.data)) this.memberOptions=res.data; }); },
    selectTagFilter(id){ id=Number(id); if(this.selectedTagId === id) return; this.selectedTagId=id; this.search(); },
    closePanel(){ if(this.submitting) return; this.detailRequestKey+=1; this.panel=''; this.detailList=[]; this.qrcodeUrl=''; },
    openMemberForm(user){
      const item=user || {};
      this.currentUser=item;
      this.memberForm={uid:Number(item.uid || 0),name:item.name || item.nickname || '',phone:item.phone || '',sex:Number(item.sex || 0),birthday:item.birthday_text || ''};
      this.panel='memberForm';
    },
    submitMember(){
      if(this.submitting) return;
      if(!this.memberForm.name){ this.$func.showToast('请输入会员姓名'); return; }
      if(!/^(1)[0-9]{10}$/.test(this.memberForm.phone)){ this.$func.showToast('请输入正确的手机号'); return; }
      this.submitting=true;
      this.$api.saveMiniMember(this.memberForm).then(res=>{
        if(res){ this.$func.showToast('保存成功'); this.panel=''; this.search(); }
      }).finally(()=>{ this.submitting=false; });
    },
    openRecharge(user){ this.currentUser=user; this.rechargeForm={money:'',gift:'',remark:''}; this.panel='recharge'; },
    submitRecharge(){
      if(this.submitting) return;
      if(Number(this.rechargeForm.money) <= 0){ this.$func.showToast('请输入充值金额'); return; }
      const money=Number(this.rechargeForm.money || 0);
      const gift=Math.max(0,Number(this.rechargeForm.gift || 0));
      const memberName=this.currentUser.name || this.currentUser.nickname || this.currentUser.phone || '当前会员';
      const content='确认给 '+memberName+' 充值￥'+money.toFixed(2)+'，赠送￥'+gift.toFixed(2)+'，实际到账￥'+(money+gift).toFixed(2)+'？';
      this.$func.confirm(content,'确认充值',()=>{ this.doSubmitRecharge(); });
    },
    doSubmitRecharge(){
      if(this.submitting) return;
      this.submitting=true;
      this.$api.rechargeMiniMember({uid:this.currentUser.uid,money:this.rechargeForm.money,gift:this.rechargeForm.gift || 0,remark:this.rechargeForm.remark}).then(res=>{
        if(res){
          const data=res.data || {};
          this.$set(this.currentUser,'money',data.money);
          this.$set(this.currentUser,'total_money',data.total_money);
          this.$set(this.currentUser,'total_gift',data.total_gift);
          this.$func.showToast('充值成功'); this.panel='';
        }
      }).finally(()=>{ this.submitting=false; });
    },
    openAssign(user){ this.currentUser=user; this.assignType=1; this.assignCardId=0; this.panel='assign'; },
    selectAssignType(type){ this.assignType=Number(type); this.assignCardId=0; },
    formatValidityDays(day, zeroText){
      const days=Number(day) || 0;
      if(days === 365) return '1年';
      if(days === 180) return '半年';
      if(days === 30) return '一个月';
      return days > 0 ? days+'天' : zeroText;
    },
    assignOptionDescription(option){
      if(this.assignType === 4) return (option.package_goods_num || 0)+'次 · '+this.formatValidityDays(option.deadline_day,'永久')+'有效';
      if(this.assignType === 1) return this.formatValidityDays(option.day,'永久')+'有效';
      if(this.assignType === 2) return '储值卡';
      const validity=Number(option.day) > 0 ? this.formatValidityDays(option.day,'')+'有效' : '不限制有效期';
      return validity+(Number(option.daily_wash_limit) > 0 ? ' · 每日'+option.daily_wash_limit+'件' : '');
    },
    submitAssign(){
      if(this.submitting || !this.assignCardId) return;
      const option=this.assignmentOptions.find(item=>Number(item.id) === Number(this.assignCardId));
      if(!option) return;
      const memberName=this.currentUser.name || this.currentUser.nickname || this.currentUser.phone || '当前会员';
      let content='确认给 '+memberName+' 分配“'+option.title+'”？';
      if(this.assignType === 2){
        const money=Number(option.money || 0);
        const gift=Number(option.gift || 0);
        content+=' 分配后余额将增加￥'+(money+gift).toFixed(2)+'。';
      }
      this.$func.confirm(content,'确认分配',()=>{ this.doSubmitAssign(); });
    },
    doSubmitAssign(){
      if(this.submitting || !this.assignCardId) return;
      this.submitting=true;
      this.$api.assignMiniMemberCard({uid:this.currentUser.uid,card_id:this.assignCardId,card_type:this.assignType}).then(res=>{
        if(res){ this.$func.showToast('分配成功'); this.panel=''; this.search(); }
      }).finally(()=>{ this.submitting=false; });
    },
    openReceive(user){ this.currentUser=user; this.panel='receive'; },
    goRecord(consumeType){
      if(consumeType === 'balance' && Number(this.currentUser.money || 0) <= 0){
        this.$func.showToast('会员余额不足，请先充值');
        return;
      }
      this.$router.push({name:'bagCodeRecord',params:{type:2},query:{phone:this.currentUser.phone,consumeType:consumeType}});
    },
    openMore(user){ this.currentUser=user; this.panel='more'; },
    openCards(user){
      this.currentUser=user; this.panel='cards'; this.resetDetailPagination(); this.loadMoreDetails();
    },
    openRecords(user,type){ this.currentUser=user; this.panel='records'; this.recordType=type; this.resetDetailPagination(); this.loadMoreDetails(); },
    loadRecords(type){
      if(this.recordType === type && this.detailList.length) return;
      this.recordType=type; this.resetDetailPagination(); this.loadMoreDetails();
    },
    resetDetailPagination(){
      this.detailRequestKey+=1; this.detailList=[]; this.detailLastId=0; this.detailHasNext=0; this.detailFinished=false; this.detailLoading=false;
    },
    loadMoreDetails(){
      if(this.detailLoading || this.detailFinished || (this.panel !== 'cards' && this.panel !== 'records')) return;
      const requestKey=this.detailRequestKey;
      const params={uid:this.currentUser.uid,last_id:this.detailLastId,page_flag:2};
      this.detailLoading=true;
      const request=this.panel === 'cards' ? this.$api.miniMemberCards(params) : this.$api.miniMemberRecords(Object.assign({},params,{type:this.recordType}));
      return request.then(res=>{
        if(requestKey !== this.detailRequestKey || !res) return;
        const rows=Array.isArray(res.data) ? res.data : [];
        rows.forEach(item=>this.detailList.push(item));
        this.detailLastId=Number(res.lastId || (this.detailLastId+1));
        this.detailHasNext=Number(res.hasNext) > 0 ? 1 : 0;
        this.detailFinished=!this.detailHasNext;
      }).finally(()=>{ if(requestKey === this.detailRequestKey) this.detailLoading=false; });
    },
    handleDetailScroll(event){
      const target=event.target;
      if(target.scrollHeight-target.scrollTop-target.clientHeight < 80) this.loadMoreDetails();
    },
    openQrcode(user){
      this.currentUser=user; this.panel='qrcode'; this.qrcodeUrl=''; this.detailLoading=true;
      this.$api.miniMemberOfficialQrcode({uid:user.uid}).then(res=>{ if(res) this.qrcodeUrl=(res.data || {}).qrcode_url || ''; }).finally(()=>{ this.detailLoading=false; });
    },
    viewUserOrders(user){ this.$router.push({name:'order',params:{type:1,i:0},query:{phone:user.phone}}); },
    viewWashRecords(user){ this.$router.push({name:'recordPhoneList',query:{phone:user.phone}}); },
    copyPhone(phone,event){ if(phone) this.$func.copy(phone,event); },
    openTagPanel(user){ this.currentUser=user; this.checkedTagIds=(user.tag_list || []).map(item=>Number(item.id)); this.panel='tags'; },
    isChecked(id){ return this.checkedTagIds.indexOf(Number(id)) > -1; },
    toggleTag(id){ id=Number(id); const index=this.checkedTagIds.indexOf(id); index > -1 ? this.checkedTagIds.splice(index,1) : this.checkedTagIds.push(id); },
    submitTags(){
      if(this.submitting) return;
      this.submitting=true;
      this.$api.saveMiniUserTags({uid:this.currentUser.uid,tag_ids:this.checkedTagIds.join(',')}).then(res=>{
        if(res){
          const selected=this.tagOptions.filter(item=>this.checkedTagIds.indexOf(Number(item.id)) > -1);
          this.$set(this.currentUser,'tag_list',selected); this.panel=''; this.$func.showToast('保存成功');
        }
      }).finally(()=>{ this.submitting=false; });
    },
    tagBgColor(color){
      if(!color || color.indexOf('#') !== 0) return '#f7f8fa';
      let hex=color.slice(1); if(hex.length === 3) hex=hex.split('').map(item=>item+item).join('');
      if(hex.length !== 6) return '#f7f8fa';
      return 'rgba('+parseInt(hex.slice(0,2),16)+','+parseInt(hex.slice(2,4),16)+','+parseInt(hex.slice(4,6),16)+',0.08)';
    },
    tagBadgeStyle(tag){ return {color:tag.color,borderColor:tag.color,backgroundColor:this.tagBgColor(tag.color)}; },
    tagOptionStyle(tag){ return this.isChecked(tag.id) ? {color:'#fff',borderColor:tag.color,backgroundColor:tag.color} : this.tagBadgeStyle(tag); },
    filterTagStyle(tag){ return this.selectedTagId === Number(tag.id) ? {color:'#fff',borderColor:tag.color,backgroundColor:tag.color} : this.tagBadgeStyle(tag); }
  }
}



// WEBPACK FOOTER //
// ./src/pages/miniUserManage.vue